export default "__VITE_ASSET__BNaV66km__"